/**
 * "procura", lowercase, in Comfortaa 300, with "for Allied CSS" in Questrial: the
 * title bar's wordmark, and since 14 October the sign-in screens' too (Arthur),
 * from this one component so the two cannot drift. The faces are for this and
 * nothing else: see .wordmark-* in index.css.
 */
export function WordmarkText({ as: Tag = 'span', tone = 'page' }: { as?: 'span' | 'h1'; tone?: 'page' | 'on-brand' }) {
  // On the brand bar both words are white (15 October, the approved mockup); the faces never change.
  const onBrand = tone === 'on-brand';
  return (
    <Tag className={`inline-flex items-baseline gap-2 ${onBrand ? 'text-on-brand' : 'text-neutral-900'}`}>
      <span className="wordmark-procura text-[2rem] leading-none">procura</span>
      <span className={`wordmark-sub text-base leading-none ${onBrand ? 'text-on-brand' : 'text-neutral-600'}`}>for Allied CSS</span>
    </Tag>
  );
}
